<!-- <div class="card border-dotted-custom">
    <div class="flex  flex-wrap w-full  card-container s-container ">
        <div class="flex  justify-content-start flex-column flex-grow-1 ">
            <div class="w-12 flex align-items-center py-2 justify-content-start font-bold text-2xl">
                Subscribed Plan: {{planName}}
            </div>
            <div class="w-12 flex align-items-center py-2 justify-content-start font-bold
                    text-xl billing-color" *ngIf="!planInfo.isFreeTrial">
                Grand Total: {{_bizzCustomerService.activeItem.currentSubscription.total| currency:'USD' | currencySpacing}}
                <span class="mx-1" *ngIf="planDuration == 1"> /month</span>
                <span class="mx-1" *ngIf="planDuration == 12"> /year</span>

            </div>
            <div *ngIf="planInfo.isFreeTrial" class="w-12 flex align-items-center py-2 justify-content-start text-lg
                    text-md link">
                {{messageText}}
            </div>
            <span *ngIf="planInfo.isFreeTrial">
                <div class="flex flex-row flex-wrap flex-grow-1  py-2 flex align-items-center
                        justify-content-start  text-lg" *ngFor="let info of currentPlanGeneralInformation">
                    <div class="flex xxl:col-3 xl:col-3 lg:col-4 md:col-4 attribute-color text-md link">
                        {{info.title}}
                    </div>
                    <div class="flex xxl:col-3 xl:col-3 lg:col-4 md:col-4 font-bold justify-content-start text-md link">
                        {{info.value}}
                    </div>
                </div>
            </span>
            <span *ngIf="!planInfo.isFreeTrial">
                <div class="flex flex-row flex-wrap  py-2 flex align-items-center
                        justify-content-start flex-grow-1 text-lg">
                    <div class="flex xxl:col-3 xl:col-3 lg:col-4 md:col-4 attribute-color text-md link">
                        Subscription Status
                    </div>
                    <div class="flex xxl:col-3 xl:col-3 lg:col-4 md:col-4 font-bold justify-content-start text-md link">
                        {{_bizzCustomerService.activeItem.currentSubscription.status ? 'Active': 'Inactive'}}
                    </div>
                </div>
                <div class="flex flex-row flex-wrap  py-2 flex align-items-center
                        justify-content-start flex-grow-1 text-lg">
                    <div class="flex xxl:col-3 xl:col-3 lg:col-4 md:col-4 attribute-color text-md link">
                        Expires on
                    </div>
                    <div class="flex xxl:col-3 xl:col-3 lg:col-4 md:col-4 font-bold justify-content-start text-md link">
                        {{_bizzCustomerService.activeItem.currentSubscription.subscriptionExpire | date:'M/d/yyyy'}}
                    </div>
                </div>
                <div class="flex flex-row flex-wrap  py-2 flex align-items-center
                        justify-content-start flex-grow-1 text-lg" *ngFor="let info of subscribedPackages">
                    <div class="flex xxl:col-3 xl:col-3 lg:col-4 md:col-4 attribute-color text-md link">
                        {{info.title}}
                        <span class="mx-1" *ngIf="info.qty> 0"> ({{info.qty}})</span>
                    </div>
                    <div class="flex xxl:col-3 xl:col-3 lg:col-4 md:col-4 font-bold justify-content-start text-md link">
                        {{info.totalPrice | currency:'USD' | currencySpacing}}
                    </div>
                </div>
                <div class="flex flex-row flex-wrap  py-2 flex align-items-center
                        justify-content-start flex-grow-1 text-lg">
                    <div class="flex xxl:col-3 xl:col-3 lg:col-4 md:col-4 attribute-color text-md link">
                        Tax
                    </div>
                    <div class="flex xxl:col-3 xl:col-3 lg:col-4 md:col-4 font-bold justify-content-start text-md link">
                        {{currentSubscription.tax | currency:'USD' | currencySpacing}}
                    </div>
                </div>
            </span>

            <div class="w-full flex align-items-center py-2 justify-content-end text-lg">
                <div class="flex w-2 col-12 text-md link">

                    <button pButton pRipple type="button" *ngIf="!cancellationRequest" [disabled]="disabledTrue"
                        (click)="cancelSubscription('c')" label="Cancel Subscription"
                        class="p-button-outlined font-bold p-button-secondary text-color-secondary"></button>
                </div>
                <div class="flex w-2  text-md link" *ngIf="!upgradeRequested">
                    <p-button label="Upgrade Subsciption" [disabled]="disabledTrue" (click)="cancelSubscription('r')">
                    </p-button>
                </div>
            </div>
        </div>
    </div>
</div> -->

<!-- Sam Changes Start -->

<div class="subscription-page" *ngIf="!loadingContent">
    <!-- Free trial -->
    <div class="sub-card sub-card--accent" *ngIf="isActuallyFreeTrial">
        <div class="sub-card-head">
            <div class="sub-card-head-left">
                <span class="sub-card-icon sub-icon-violet"><i class="pi pi-gift"></i></span>
                <div>
                    <span class="sub-card-title">Subscribed Plan</span>
                    <span class="sub-card-desc">Currently on a free trial</span>
                </div>
            </div>
            <span class="sub-plan-pill">{{ planName }}</span>
        </div>
        <!-- TODO re-enable: hidden per request -->
        <div class="sub-grid" *ngIf="EXPIRES_ON_TILE_ENABLED">
            <div class="sub-tile" *ngFor="let info of currentPlanGeneralInformation">
                <span class="sub-tile-label"><i class="pi pi-calendar"></i> {{ info.title }}</span>
                <span class="sub-tile-value">{{ info.value }}</span>
            </div>
        </div>
    </div>

    <!-- Paid subscription -->
    <ng-container *ngIf="!isActuallyFreeTrial">
        <div class="sub-card">
            <div class="sub-card-head">
                <div class="sub-card-head-left">
                    <span class="sub-card-icon sub-icon-primary"><i class="pi pi-credit-card"></i></span>
                    <div>
                        <span class="sub-card-title">Subscription Plan</span>
                        <span class="sub-card-desc">Current billing details</span>
                    </div>
                </div>
                <div class="sub-head-actions">
                    <span class="sub-status-pill"
                        [class.sub-status-pill--active]="_bizzCustomerService.activeItem?.currentSubscription?.status"
                        [class.sub-status-pill--inactive]="!_bizzCustomerService.activeItem?.currentSubscription?.status">
                        <i class="pi pi-circle-fill"></i>
                        {{ _bizzCustomerService.activeItem?.currentSubscription?.status ? "Active" : "Inactive" }}
                    </span>
                    <p-button
                        *ngIf="false"
                        label="Upgrade Plan"
                        icon="pi pi-arrow-up-right"
                        [disabled]="disabledTrue"
                        (click)="upgradePlan()"
                    ></p-button>
                </div>
            </div>

            <div class="sub-grid">
                <div class="sub-tile">
                    <span class="sub-tile-label"><i class="pi pi-star"></i> Current Plan</span>
                    <span class="sub-tile-value">{{ displayPlanName }}</span>
                </div>
                <div class="sub-tile">
                    <span class="sub-tile-label"><i class="pi pi-sync"></i> Payment Interval</span>
                    <span class="sub-tile-value">{{ _bizzCustomerService.activeItem.currentSubscription?.subscriptionInterval == 1 ? "Monthly" : "Yearly" }}</span>
                </div>
                <div class="sub-tile sub-tile--highlight">
                    <span class="sub-tile-label"><i class="pi pi-dollar"></i> Next Payment <small>(incl. tax)</small></span>
                    <span class="sub-tile-value">{{ displayNextPaymentAmount | currency:'USD' | currencySpacing }}</span>
                    <small class="sub-tile-breakdown" *ngIf="hasNextPaymentTaxBreakdown">
                        {{ displayNextPaymentSubtotal | currency:'USD' | currencySpacing }} + {{ displayNextPaymentTaxAmount | currency:'USD' | currencySpacing }} tax
                    </small>
                </div>
                <div class="sub-tile" *ngIf="hasSubscribedOnDate">
                    <span class="sub-tile-label"><i class="pi pi-calendar"></i> Subscribed On</span>
                    <span class="sub-tile-value">{{ formatDisplayDate(displaySubscribedOnDate) }}</span>
                </div>
                <div class="sub-tile">
                    <span class="sub-tile-label"><i class="pi pi-calendar-plus"></i> Next Due Date</span>
                    <span class="sub-tile-value">{{ formatDisplayDate(displayNextDueDate) }}</span>
                </div>
                <div class="sub-tile" *ngIf="hasLastChargeDate()">
                    <span class="sub-tile-label"><i class="pi pi-history"></i> Last Charge</span>
                    <span class="sub-tile-value">{{ formatDisplayDate(_bizzCustomerService.activeItem.currentSubscription?.lastChargeDate) }}</span>
                </div>
            </div>
            <div class="sub-plan-change-note" *ngIf="lastPlanChange as change">
                Changed from {{ change.fromTitle }} to {{ change.toTitle }} on {{ formatDisplayDate(change.date) }}
            </div>
            <div class="sub-plan-change-note sub-plan-change-note--pending" *ngIf="pendingPlanChangeRequest as pending">
                Plan change request pending<ng-container *ngIf="pending.status">&nbsp;({{ pending.status }})</ng-container><ng-container *ngIf="pending.date"> — requested {{ formatDisplayDate(pending.date) }}</ng-container>
                <div *ngIf="pending.message">{{ pending.message }}</div>
            </div>
        </div>

        <div class="sub-card" *ngIf="showLocationsRegistersCard">
            <div class="sub-card-head">
                <div class="sub-card-head-left">
                    <span class="sub-card-icon sub-icon-blue"><i class="pi pi-map-marker"></i></span>
                    <div>
                        <span class="sub-card-title">Locations & Registers</span>
                        <span class="sub-card-desc">Every plan includes 1 location and 1 register.</span>
                    </div>
                </div>
            </div>

            <div class="sub-usage-row">
                <div class="sub-usage-info">
                    <span class="sub-usage-title">Locations</span>
                    <span class="sub-usage-desc">{{ includedLocationCount }} included &middot; {{ locationExtraPrice | currency:'USD' | currencySpacing }}/mo each extra</span>
                </div>
                <div class="sub-usage-count">
                    <span class="sub-usage-total">{{ totalLocationCount }}</span>
                    <span class="sub-usage-extra" *ngIf="extraLocationCount > 0">{{ extraLocationCount }} extra</span>
                </div>
            </div>
            <div class="sub-usage-row">
                <div class="sub-usage-info">
                    <span class="sub-usage-title">Registers</span>
                    <span class="sub-usage-desc">{{ includedRegisterCount }} included &middot; {{ registerExtraPrice | currency:'USD' | currencySpacing }}/mo each extra</span>
                </div>
                <div class="sub-usage-count">
                    <span class="sub-usage-total">{{ totalRegisterCount }}</span>
                    <span class="sub-usage-extra" *ngIf="extraRegisterCount > 0">{{ extraRegisterCount }} extra</span>
                </div>
            </div>
        </div>

        <div class="sub-card" *ngIf="showAddonsCard">
            <div class="sub-card-head">
                <div class="sub-card-head-left">
                    <span class="sub-card-icon sub-icon-violet"><i class="pi pi-star"></i></span>
                    <div>
                        <span class="sub-card-title">Add-ons</span>
                        <span class="sub-card-desc">Optional features billed alongside this subscription.</span>
                    </div>
                </div>
                <p-tag [value]="activeLiveAddonCount + ' of ' + liveSubscriptionAddonsList.length + ' active'"></p-tag>
            </div>

            <div class="sub-usage-row" *ngFor="let addon of liveSubscriptionAddonsList">
                <div class="sub-usage-info">
                    <span class="sub-usage-title">{{ addon.planName }}</span>
                    <span class="sub-usage-desc">{{ addon.monthlyPrice | currency:'USD' | currencySpacing }}/mo</span>
                </div>
                <p-tag [value]="addon.included ? 'Included' : 'Not purchased'" [severity]="addon.included ? 'success' : 'info'"></p-tag>
            </div>
        </div>

        <div class="sub-card">
            <div class="sub-card-head">
                <div class="sub-card-head-left">
                    <span class="sub-card-icon sub-icon-blue"><i class="pi pi-list"></i></span>
                    <div>
                        <span class="sub-card-title">Subscription Details</span>
                        <span class="sub-card-desc">Line items on this subscription</span>
                    </div>
                </div>
            </div>

            <div class="sub-table-wrap">
                <p-table
                    styleClass="p-datatable-striped sub-table"
                    [value]="displaySubscriptionLineItems"
                    responsiveLayout="scroll"
                    rowHover="true"
                >
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Subscription / Addons</th>
                            <th style="text-align: center">Qty</th>
                            <th style="text-align: right">Price (without Tax)</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-info>
                        <tr>
                            <td>{{ info.title }}</td>
                            <td style="text-align: center">{{ info.displayQty }}</td>
                            <td style="text-align: right">{{ info.displayPrice | currency:'USD' | currencySpacing }}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="3" style="text-align: center">No data found</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

            <div class="sub-summary">
                <div class="sub-summary-row">
                    <span>Sub Total</span>
                    <span>{{ displaySubTotalAmount | currency:'USD' | currencySpacing }}</span>
                </div>
                <div class="sub-summary-row">
                    <span>Tax</span>
                    <span>{{ displayTaxAmount | currency:'USD' | currencySpacing }}</span>
                </div>
                <div class="sub-summary-row sub-summary-row--total">
                    <span>Total Charges</span>
                    <span>{{ displayTotalChargesAmount | currency:'USD' | currencySpacing }}</span>
                </div>
            </div>

            <div class="sub-card-foot"
                *ngIf="!cancellationRequest && _globals.whiteLabel?.isStripe === false">
                <button
                    [disabled]="disabledTrue"
                    pButton
                    pRipple
                    type="button"
                    label="Cancel Subscription"
                    icon="pi pi-times"
                    class="p-button-outlined p-button-danger"
                    (click)="cancelSubscription('c')"
                ></button>
            </div>
        </div>
    </ng-container>
</div>
<div class="field xxl:col-12 xl:col-12 col-12 md:col-6" *ngIf="loadingContent">
    <p-skeleton styleClass="mb-2"></p-skeleton>
    <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
    <p-skeleton width="5rem" styleClass="mb-2"></p-skeleton>
    <p-skeleton height="2rem" styleClass="mb-2"></p-skeleton>
    <p-skeleton width="10rem" height="4rem"></p-skeleton>
</div>

<p-dialog
    header="Confirmation"
    [(visible)]="ShowCustomConfirmation"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
>
    <div *ngIf="upgradeSucessMessage.length == 0" class="plan-upgrade-message">
        <strong
            >You have chosen to
            {{ CurrentAction == 1 ? "upgrade" : "downgrade" }} your
            plan.</strong
        >
        <br /><br />
        <table class="p-datatable-table ng-star-inserted upgrade-plan">
            <tr class="ng-star-inserted">
                <td>
                    From: <strong>{{ planName }} plan</strong>
                </td>
                <td>
                    <strong>${{ currentSubscriptionCharges }}</strong>
                    {{
                        (this._bizzCustomerService.activeItem
                            ?.currentSubscription?.subscriptionInterval === 12
                            ? "/ Year "
                            : "/ Month") + "(Subscription + Addons + Tax)"
                    }}
                </td>
            </tr>
            <tr class="ng-star-inserted">
                <td>
                    To:
                    <strong
                        >{{ getSelectedPlanTitle() }} plan</strong
                    >
                </td>
                <td>
                    <strong>${{ newSubscriptionCharges }}</strong>
                    {{
                        (this._bizzCustomerService.activeItem
                            ?.currentSubscription?.subscriptionInterval === 12
                            ? "/ Year"
                            : "/ Month") + "(Subscription + Addons + Tax)"
                    }}
                </td>
            </tr>
        </table>
        <p-divider *ngIf="subscriptionChangeNotes.length > 0">
            <p style="font-size: 18px">{{ subscriptionChangeNotes }}</p>
        </p-divider>
        <br />
        Would you like to proceed?
    </div>
    <div *ngIf="upgradeSucessMessage.length > 0" class="plan-upgrade-message">
        <p>You have sucessfully updated your plan</p>
    </div>

    <div class="flex flex-wrap">
        <div class="flex align-items-center justify-content-center m-2">
            <button
                pButton
                type="button"
                label="Confirm"
                *ngIf="upgradeSucessMessage.length == 0"
                class="ml-2"
                style="width: 160px"
                (click)="performAction()"
            ></button>
            <button
                pButton
                type="button"
                label="Ok"
                class="ml-2"
                style="width: 160px"
                (click)="ShowCustomConfirmation = false"
                *ngIf="upgradeSucessMessage.length > 0"
            ></button>
            <button
                pButton
                type="button"
                label="Cancel"
                *ngIf="upgradeSucessMessage.length == 0"
                class="ml-2"
                style="width: 160px"
                (click)="ShowCustomConfirmation = false"
            ></button>
        </div>
    </div>

    <div style="color: red" *ngIf="ErrorMessage.length > 0">
        <br />
        <br />
        {{ ErrorMessage }}
    </div>
</p-dialog>

<p-dialog
    header="Confirmation"
    [(visible)]="showSubscriptionModal"
    [modal]="true"
    [style]="{ width: '50vw' }"
    [draggable]="true"
    [resizable]="false"
>
    <p class="m-0">
        Thank you for reaching out to us regarding your request. We have
        received your message and our customer support team will be in touch
        with you shortly to assist you with your query.
    </p>
</p-dialog>

<p-dialog
    header="Add Registers"
    [(visible)]="showBuyMoreRegisterForm"
    [blockScroll]="true"
    modal="true"
    [breakpoints]="{
        '960px': '80vw',
        '640px': '90vw',
        '250px': '100vw'
    }"
    [draggable]="false"
    [style]="{ width: '60vw' }"
>
    <ng-container>
        <p>
            You are going to change number of Registers available to you. Buying
            any additional location will be charged according to your selected
            payment interval and subscription plan.
        </p>
        <br />
        <div class="nas-grid-2x m-2">
            <div class="nas-label">Current Registers</div>
            <div class="">
                <div class="">
                    <input
                        type="number"
                        min="0"
                        placeholder="Enter a number"
                        [(ngModel)]="currentRegisters.qty"
                        disabled
                        pInputText
                        style="width: 100%"
                    />
                </div>
            </div>
        </div>
        <div class="nas-grid-2x m-2">
            <div class="nas-label">Additional Registers</div>
            <div class="">
                <input
                    type="number"
                    min="0"
                    placeholder="Enter a number"
                    [(ngModel)]="buyRegQty"
                    pInputText
                />
                <button
                    pButton
                    type="button"
                    label="Update Cart"
                    class="ml-2"
                    style="width: 130px"
                    (click)="registerQtyChanged($event)"
                    [disabled]="buyRegQty == 0"
                ></button>
            </div>
        </div>
        <div class="nas-grid-2x m-2">
            <div class="nas-label">Additional Charges</div>
            <div class="">
                <input
                    [(ngModel)]="buylocationList.additionalCost"
                    [(ngModel)]="currentRegisters.qty"
                    disabled
                    (onInput)="locationQtyChanged($event)"
                    pInputText
                    style="width: 100%"
                />
            </div>
        </div>
        <div class="nas-grid-2x m-2">
            <div class="nas-label">New Charges</div>
            <div class="">
                <p-inputNumber
                    mode="currency"
                    [(ngModel)]="buyRegisterList.additionalCost"
                    currency="USD"
                    locale="en-US"
                    [disabled]="true"
                ></p-inputNumber>
            </div>
        </div>
        <!-- <div class="" *ngIf="buyRegisterList.note.length>0">
        <div class="nas-label">{{buyRegisterList.note}}
        </div>

    </div> -->
    </ng-container>

    <div class="flex justify-content-end flex-wrap">
        <div class="flex align-items-center justify-content-center m-2">
            <button
                pButton
                type="button"
                label="Purchase"
                class="ml-2"
                style="width: 130px"
                (click)="postBuyRegisters()"
                [disabled]="buyRegQty == 0"
            ></button>
        </div>
    </div>
</p-dialog>

<p-dialog
    header="Add More Inventory Locations"
    [(visible)]="showBuyMoreLocationForm"
    [blockScroll]="true"
    modal="true"
    [draggable]="false"
    [breakpoints]="{
        '960px': '80vw',
        '640px': '90vw',
        '250px': '100vw'
    }"
    [style]="{ width: '60vw' }"
>
    <ng-container>
        <p>
            You are going to change number of locations available to you. Buying
            any additional location will be charged according to your selected
            payment interval and subscription plan. First register for every new
            location is free!.
        </p>
        <br />
        <div class="nas-grid-2x m-2">
            <div class="nas-label">Current Inventory Locations</div>
            <div class="">
                <div class="">
                    <input
                        type="number"
                        min="0"
                        placeholder="Enter a number"
                        [(ngModel)]="currentLocations.qty"
                        disabled
                        (onInput)="locationQtyChanged($event)"
                        pInputText
                        style="width: 100%"
                    />
                </div>
            </div>
        </div>
        <div class="nas-grid-2x m-2">
            <div class="nas-label">Additional Location to Buy</div>
            <div class="">
                <input
                    type="number"
                    min="0"
                    placeholder="Enter a number"
                    [(ngModel)]="buyLocQty"
                    pInputText
                />
                <button
                    pButton
                    type="button"
                    label="Update Cart"
                    class="ml-2"
                    style="width: 130px"
                    (click)="locationQtyChanged($event)"
                    [disabled]="buyLocQty == 0"
                ></button>
            </div>
        </div>
        <div class="nas-grid-2x m-2">
            <div class="nas-label">Additional Cost</div>
            <div class="">
                <input
                    [(ngModel)]="buylocationList.additionalCost"
                    placeholder="Enter a number"
                    [(ngModel)]="currentLocations.qty"
                    disabled
                    (onInput)="locationQtyChanged($event)"
                    pInputText
                    style="width: 100%"
                />
            </div>
        </div>
        <div class="nas-grid-2x m-2">
            <div class="nas-label">New Charges</div>
            <div class="">
                <p-inputNumber
                    mode="currency"
                    [(ngModel)]="buylocationList.newSubscriptionCharges"
                    currency="USD"
                    locale="en-US"
                    [disabled]="true"
                ></p-inputNumber>
            </div>
        </div>
        <!-- <div class="" *ngIf="buylocationList.note.length>0">
        <div class="nas-label">{{buylocationList.note}}
        </div>

    </div> -->
    </ng-container>
    <div class="flex justify-content-end flex-wrap">
        <div class="flex align-items-center justify-content-center m-2">
            <button
                pButton
                type="button"
                label="Purchase"
                class="ml-2"
                style="width: 130px"
                (click)="postBuyLocation()"
                [disabled]="buyLocQty == 0"
            ></button>
        </div>
    </div>
</p-dialog>

<p-dialog
    header="Support Request"
    [(visible)]="showSupportRequestForm"
    [blockScroll]="true"
    modal="true"
    [breakpoints]="{
        '960px': '80vw',
        '640px': '90vw',
        '250px': '100vw'
    }"
    [draggable]="false"
    [style]="{ width: '40vw' }"
>
    <ng-container>
        <br />
        <div class="nas-grid-2x m-2">
            <div class="nas-label">Subject</div>
            <div class="">
                <input
                    type="text"
                    [(ngModel)]="generalQuestion"
                    pInputText
                    style="width: 100%"
                />
            </div>
        </div>
        <div class="nas-grid-2x m-2">
            <div class="nas-label">Anything to add?</div>
            <div class="">
                <textarea
                    [rows]="5"
                    [cols]="30"
                    [(ngModel)]="generalMessage"
                    pInputTextarea
                    style="width: 100%"
                >
​</textarea
                >
            </div>
        </div>
    </ng-container>
    <div class="flex justify-content-end flex-wrap">
        <div class="flex align-items-center justify-content-center m-2">
            <button
                pButton
                type="button"
                label="Submit Request"
                class="ml-2"
                (click)="submitGeneralRequest()"
            ></button>
        </div>
    </div>
</p-dialog>
<p-dialog
    header="Contact Support for Additional Addons "
    [(visible)]="talkToExpertForm"
    [blockScroll]="true"
    modal="true"
    [breakpoints]="{
        '960px': '80vw',
        '640px': '90vw',
        '250px': '100vw'
    }"
    [draggable]="false"
    [style]="{ width: '40vw' }"
>
    <ng-container>
        <br />
        <div class="nas-grid-2x m-2">
            <div class="nas-label">Your Question</div>
            <div class="">
                <input
                    type="text"
                    [(ngModel)]="addtionalAddonsQuestion"
                    pInputText
                    style="width: 100%"
                />
            </div>
        </div>
        <div class="nas-grid-2x m-2">
            <div class="nas-label">Details</div>
            <div class="">
                <textarea
                    [rows]="5"
                    [cols]="30"
                    [(ngModel)]="additionalAddonRequestionMessage"
                    pInputTextarea
                    style="width: 100%"
                >
​</textarea
                >
            </div>
        </div>
    </ng-container>
    <div class="flex justify-content-end flex-wrap">
        <div class="flex align-items-center justify-content-center m-2">
            <button
                pButton
                type="button"
                label="Submit Request"
                class="ml-2"
                style="width: 160px"
                (click)="submitTalkExpertFormRequest()"
            ></button>
        </div>
    </div>
</p-dialog>

<p-dialog
    header="Addons and optional Features​"
    [(visible)]="showPurchaseAddon"
    [blockScroll]="true"
    modal="true"
    [breakpoints]="{
        '960px': '80vw',
        '640px': '90vw',
        '250px': '100vw'
    }"
    [draggable]="false"
    [style]="{ width: '40vw' }"
>
    <ng-container *ngIf="!isActuallyFreeTrial">
        <p-table
            styleClass="p-datatable-striped"
            [tableStyle]="{ width: 'max-content' }"
            [value]="getSubPlan?.plans[0]?.featureData"
            responsiveLayout="scroll"
            rowHover="true"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Addon</th>
                    <th style="text-align: left">Price</th>
                    <!-- <th style="text-align: left">Status</th> -->
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-info>
                <tr *ngIf="info.typeString == 'StaticWebsite'">
                    <td>Website/ Basic eCommerce Store</td>
                    <td style="text-align: left">
                        Starting from {{ info.price | currency:'USD' | currencySpacing }}
                    </td>
                </tr>
                <tr *ngIf="info.typeString == 'LoyaltyProgram'">
                    <td>{{ info.title }}</td>
                    <td style="text-align: left">
                        {{ info.price | currency:'USD' | currencySpacing }}
                    </td>
                    <!-- <td style="text-align: left">
                        <button pButton type="button" label="Request Support" (click)="generateSupportRequest('Support Request Loyalty Program Subscription')"></button>
                    </td> -->
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" style="text-align: center">
                <tr>
                    <td colspan="17" style="text-align: center">
                        No data found
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </ng-container>
</p-dialog>

<p-dialog
    header="Select Website​"
    [(visible)]="showWebsiteSelectionPopup"
    [blockScroll]="true"
    modal="true"
    [breakpoints]="{
        '960px': '80vw',
        '640px': '90vw',
        '250px': '100vw'
    }"
    [draggable]="false"
    [style]="{ width: '70vw' }"
>
    <app-signup-website-and-online-store> </app-signup-website-and-online-store>
</p-dialog>

<p-dialog
    header="Select Loyalty Program"
    [(visible)]="showLoyaltyProgramSelectionPopup"
    [blockScroll]="true"
    modal="true"
    [breakpoints]="{
        '960px': '80vw',
        '640px': '90vw',
        '250px': '100vw'
    }"
    [draggable]="false"
    [style]="{ width: '70vw' }"
>
    <app-signup-loyalty-program> </app-signup-loyalty-program>
</p-dialog>
<p-dialog
    header="Please select subscription to modify"
    modal="true"
    [closable]="false"
    [(visible)]="displaySubscriptionPlan"
    [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
    [style]="{ width: '95vw' }"
>
    <ng-template pTemplate="footer">
        <button
            pButton
            type="button"
            (click)="closeSubscriptionModal(1)"
            class="p-button-secondary"
            label="Close"
        ></button>
        <button
            pButton
            type="button"
            [disabled]="!planChanged"
            class="checkout-popup-btn-save"
            (click)="closeSubscriptionModal(2)"
            label="Save Changes"
        ></button>
    </ng-template>
    <app-subscription-plans-layout
        [showFooter]="false"
        [showTrial]="false"
        [AlreadySubscribedCustomer]="false"
        [DefaultInterval]="
            _bizzCustomerService.activeItem?.currentSubscription
                ?.subscriptionInterval
        "
        [AllowQtyChange]="_bizzCustomerService.activeItem.isFreeTrial"
        (subscriptionPlanChanged)="subscriptionPlanChanged($event)"
        (closeDialogSubscriptionPlan)="closeDialogSubscriptionPlan($event)"
    ></app-subscription-plans-layout>
</p-dialog>
